// Keep the floating contacts clear of carousel controls, including short screens.
// Only the fixed overlay moves; no page dimensions or spacing are changed.
const contacts = document.querySelector('.sopper-contacts');

if (contacts) {
  let shift = 0;
  let scheduled = false;

  const update = () => {
    scheduled = false;
    const controls = document.querySelector('.sopper-carousel__controls');
    const rail = contacts.getBoundingClientRect();
    const baseTop = rail.top + shift;
    let nextShift = 0;

    if (controls) {
      const target = controls.getBoundingClientRect();
      const overlaps = rail.left < target.right && rail.right > target.left &&
        baseTop < target.bottom + 8 && baseTop + rail.height > target.top - 8;

      if (overlaps) {
        const headerBottom = Math.max(0, document.querySelector('#header-group')?.getBoundingClientRect().bottom ?? 0);
        const above = target.top - rail.height - 8;
        const below = target.bottom + 8;
        if (above >= headerBottom + 8) nextShift = baseTop - above;
        else if (below + rail.height <= window.innerHeight - 8) nextShift = baseTop - below;
      }
    }

    if (nextShift !== shift) {
      shift = nextShift;
      contacts.style.setProperty('--sopper-contact-shift', `${shift}px`);
    }
  };

  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(update);
  };

  document.addEventListener('scroll', schedule, { passive: true, capture: true });
  window.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:section:unload', schedule);
  const resizeObserver = new ResizeObserver(schedule);
  resizeObserver.observe(contacts);
  resizeObserver.observe(document.documentElement);
  schedule();
}
